import React from 'react';
import PropTypes from 'prop-types';
import { Wrap } from './styles';
import VerticalLines from './VerticalLines';
import Cards from './Cards';

const Body = ({ headers, projects, viewBy, possibleStatus }) => {
  return (
    <Wrap>
      <VerticalLines headers={headers} size={projects.length} viewBy={viewBy} />
      {possibleStatus && (
        <Cards
          headers={headers}
          projects={projects}
          viewBy={viewBy}
          possibleStatus={possibleStatus}
        />
      )}
    </Wrap>
  );
};

Body.propTypes = {
  viewBy: PropTypes.number,
  headers: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.instanceOf(Date).isRequired,
      format: PropTypes.string,
      id: PropTypes.number,
    }),
  ).isRequired,
  projects: PropTypes.arrayOf(
    PropTypes.shape({
      ID: PropTypes.string,
      name: PropTypes.string,
      objCode: PropTypes.string,
      percentComplete: PropTypes.number,
      plannedCompletionDate: PropTypes.string,
      plannedStartDate: PropTypes.string,
      progressStatus: PropTypes.string,
      project: PropTypes.shape({
        ID: PropTypes.string,
        name: PropTypes.string,
        objCode: PropTypes.string,
        percentComplete: PropTypes.number,
        plannedCompletionDate: PropTypes.string,
        plannedStartDate: PropTypes.string,
      }),
    }),
  ).isRequired,
  possibleStatus: PropTypes.arrayOf(PropTypes.shape(PropTypes.string)),
};

Body.defaultProps = {
  viewBy: null,
  possibleStatus: [{}],
};

export default Body;
